"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_PAGE_MISSION_MAX_LENGTH = void 0;
exports.ORGANIZATION_PAGE_MISSION_MAX_LENGTH = 50_000;
